import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--meterFillColor, #ADC6FA)",
  d: "M2.936 13.36c0-3.034 1.177-4.478 3.14-5.494l1.962 2.585-1.686 2.91H2.936Zm3.139-5.656c3.14-2.688 5.747-1.072 7.85-.392l-1.963 3.532-3.924-.393-1.963-2.747Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.352 13.5c-.352-3-.852-4-2.926-5.925L12 11l1 2.5h4.352Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.437 12.95h2.446a4.068 4.068 0 0 1 1.278-2.313L5.82 8.543a6.59 6.59 0 0 0-2.382 4.407ZM6.99 7.775 8.346 9.89a3.98 3.98 0 0 1 .954-.257V8.489a.7.7 0 1 1 1.4 0v1.194c.312.067.61.17.892.305l1.418-2.213A6.572 6.572 0 0 0 10 7.05a6.572 6.572 0 0 0-3.01.725Zm7.19.768-1.45 2.262c.565.575.96 1.319 1.104 2.145h2.73a6.59 6.59 0 0 0-2.383-4.407Zm-3.48 2.59a2.663 2.663 0 0 1 1.795 2.517.7.7 0 0 0 .7.7H17.3a.7.7 0 0 0 .7-.7 8 8 0 1 0-16 0 .7.7 0 0 0 .7.7h3.823a.7.7 0 0 0 .7-.7A2.66 2.66 0 0 1 9.3 11.055v2.536a.7.7 0 1 0 1.4 0v-2.457Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=MeterTwoIcon20.js.map